// Import Packages
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Checkboxes } from "../../../FlowConfigurationInputs";

// Import Pages
import { TextInput } from '../../../FlowConfigurationInputs/TextInput/NewTextInput';
import AppCredential from '../AppCredential/AppCredential';

// Import Recoil
import { useRecoilState } from "recoil";
import { activeAutom } from "../../../../recoil-store/recoil-state";


function Text({
    action,
    variables,
    setOpenVariable,
    automId,
    showAlert,
    automVersionId,
    automaticallyWhatsappVariableCreation
}) {
    const { t } = useTranslation();
    const label = 'CONTENT.CONFIGURATION-FORM.WHATSAPP.TEXT.';

    const [isQuestion, setIsQuestion] = useState(false);
    const [outLabel, setOutLabel] = useState({ isOk: false, value: "" });
    const [automDetail, setAutomDetail] = useRecoilState(activeAutom);
    useEffect(() => {
        setIsQuestion(action.fields.isQuestion?.value);
        if (!action.fields.isQuestion?.value) {
            delete action.fields.set
        }
    }, [action])

    useEffect(() => {
        if (action.fields?.label) {
            setOutLabel({ isOk: true, value: action.fields.label.value })
        }
    }, [action?.fields?.label?.value])

    const updateLabel = (id, items) => {
        let isDifferentLabel
        const innerUpdateLabel = (id, items) => {
            items.forEach(item => {
                if (item.id === id) {
                    item.fields = action.fields;
                    if (item.label !== action.fields.label.value && (item.label !== undefined || action.fields.label.value)) {
                        item.label = action.fields.label.value;
                        isDifferentLabel = true
                    }
                } else if (item.children) {
                    innerUpdateLabel(id, item.children);
                }
            });
        }
        innerUpdateLabel(id, items)
        return isDifferentLabel
    };

    const handleBlur = () => {
        let fields = action.fields;
        let items = JSON.parse(JSON.stringify(automDetail.items));
        action.fields = JSON.parse(JSON.stringify(fields));
        const isLabelsDifferent = updateLabel(action.id, items);
        if (!isLabelsDifferent) return
        setAutomDetail({ ...automDetail, items: JSON.parse(JSON.stringify(items)) });
    };

    const changeIsQuestion = (status) => {
        setIsQuestion(status);
        if (status) {
            const variableSlug = `${action.actionName.toLowerCase()}_${action.item_id.replaceAll('-', '')}`
            const variableName = `##${action.actionName.toLowerCase()}_${action.item_id.replaceAll('-', '')}##`
            const variableAlreadyExists = variables.some(x => x.name === variableSlug)

            if (!variableAlreadyExists) {
                automaticallyWhatsappVariableCreation(action.item_id, action.actionName)
            }

            action.fields.set = {
                conditions: [],
                value: variableName
            }
        } else {
            // TODO delete variable action here
            delete action.fields.set
        }

    }


    return (
        <div>
            <AppCredential action={action} />
            <div className="form-element">
                {t(label + "LABEL")}
                <TextInput
                    action={action}
                    inputName="label"
                    variables={variables}
                    setOpenVariable={setOpenVariable}
                    isRequired={false}
                    onBlur={handleBlur}
                    fieldType="string"
                    displayName={t(label + "LABEL")}
                    outNewValue={outLabel}
                    limit={40}
                />
            </div>
            <div className="form-element">
                {t(label + 'MESSAGE')}
                <TextInput action={action} inputName="message" variables={variables}
                    setOpenVariable={setOpenVariable} multiline rows={4} fieldType="string"
                    displayName={t(label + 'MESSAGE')} />
                <small
                    className="conf-field-desc"><em>{t(label + 'MESSAGE-HELPER', { type: 'string' })}</em></small>
            </div>
            <div className="form-element">
                <Checkboxes
                    action={action}
                    itemtype="app_connector"
                    inputName="isQuestion"
                    onChange={() => changeIsQuestion(!isQuestion)}
                    options={{ label: label + "IS-QUESTION" }}
                    isRequired={false}
                />
            </div>
            {isQuestion && (
                <div className="form-element">
                    {t(label + 'RESPONSE')}
                    <TextInput action={action} inputName="set" variables={variables} disabled={true}
                        setOpenVariable={setOpenVariable} rows={4} fieldType="string"
                        displayName={t(label + 'RESPONSE')} />
                </div>
            )}
        </div>
    );
}

export default Text;
